module.exports = __webpack_public_path__ + "static/media/default-skin.4c8cdc3f.svg";